import { render, staticRenderFns } from "./FixedInBottom.vue?vue&type=template&id=4886b38e&"
import script from "./FixedInBottom.vue?vue&type=script&lang=js&"
export * from "./FixedInBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports